<script lang="ts">
	import { Input } from '$lib/components';

	type Props = {
		id: string;
		name: string;
		value?: string;
		label: string;
		error?: string | string[] | undefined;
		setValue?: (value: string) => void;
	};

	let touch = $state<boolean>(false);
	let hour = $state('');
	let minute = $state('');
	let { id, name, value = '', label, error, setValue }: Props = $props();

	const setTime = (v: string) => {
		value = v;
		setValue?.(v);
	};

	$effect(() => {
		if (value && hour === '' && minute === '') {
			const [h, m] = value.split(':');
			hour = h;
			minute = m;
		}
		if (hour !== '' && minute === '') {
			minute = '00';
		}
		if (hour !== '' && minute !== '') {
			error = undefined;
			const h = hour.padStart(2, '0');
			const m = minute.padStart(2, '0');
			setTime(`${h}:${m}`);
		}
	});
	let pmam = $derived(hour && Number(hour) < 12 ? 'AM' : 'PM');

	function handleTimeChange(event: Event) {
		const target = event.target as HTMLInputElement;
		setTime(target.value);
	}
</script>

<Input {error}>
	<label for="{id}-hour" class="input-label">{label}</label>
	{#if touch}
		<input
			type="time"
			id="search-time"
			{value}
			oninput={handleTimeChange}
			{name}
			class="w-auto text-left"
		/>
	{:else}
		<div class="flex space-x-1">
			<select name="hour" id="{id}-hour" class="time" bind:value={hour}>
				{#if hour === ''}
					<option value="">--</option>
				{/if}
				<!-- eslint-disable-next-line @typescript-eslint/no-unused-vars -->
				{#each Array(24) as _, h}
					{@const hh = String(h).padStart(2, '0')}
					<option value={hh}>{hh}</option>
				{/each}
			</select>
			<div class="px-1">:</div>
			<select name="minute" id="{id}-minute" class="time" bind:value={minute}>
				{#if minute === ''}
					<option value="">--</option>
				{/if}
				<!-- eslint-disable-next-line @typescript-eslint/no-unused-vars -->
				{#each Array(12) as _, m}
					{@const mm = String(m * 5).padStart(2, '0')}
					<option value={mm}>{mm}</option>
				{/each}
			</select>
			<div class="pl-2">{pmam}</div>
			<input type="hidden" {name} {value} />
		</div>
	{/if}
</Input>

<style>
	.time {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		width: auto;
	}
</style>
